'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThLarge = function TiThLarge(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 5h-3.3c-1.4 0-2.6 0.6-3.5 1.5s-1.5 2.1-1.5 3.5v3.3c0 1.4 0.6 2.7 1.5 3.6s2.1 1.4 3.5 1.4h3.3c1.4 0 2.7-0.5 3.6-1.4s1.4-2.2 1.4-3.6v-3.3c0-1.4-0.5-2.6-1.4-3.5s-2.2-1.5-3.6-1.5z m16.7 0h-3.3c-1.4 0-2.7 0.6-3.6 1.5s-1.4 2.1-1.4 3.5v3.3c0 1.4 0.5 2.7 1.4 3.6s2.2 1.4 3.6 1.4h3.3c1.4 0 2.6-0.5 3.5-1.4s1.5-2.2 1.5-3.6v-3.3c0-1.4-0.6-2.6-1.5-3.5s-2.1-1.5-3.5-1.5z m-16.7 16.7h-3.3c-1.4 0-2.6 0.5-3.5 1.4s-1.5 2.2-1.5 3.6v3.3c0 1.4 0.6 2.6 1.5 3.5s2.1 1.5 3.5 1.5h3.3c1.4 0 2.7-0.6 3.6-1.5s1.4-2.1 1.4-3.5v-3.3c0-1.4-0.5-2.7-1.4-3.6s-2.2-1.4-3.6-1.4z m16.7 0h-3.3c-1.4 0-2.7 0.5-3.6 1.4s-1.4 2.2-1.4 3.6v3.3c0 1.4 0.5 2.6 1.4 3.5s2.2 1.5 3.6 1.5h3.3c1.4 0 2.6-0.6 3.5-1.5s1.5-2.1 1.5-3.5v-3.3c0-1.4-0.6-2.7-1.5-3.6s-2.1-1.4-3.5-1.4z' })
        )
    );
};

exports.default = TiThLarge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/th-large.js
// module id = 3238
// module chunks = 0